import { arrowLeft, arrowRight } from "helper/icons";
export const MobilePaginationAlt = ({
  currentPage,
  totalPages,
  handlePageChange,
}) => {
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };
  return (
    <div className="flex justify-between h-14  items-center px-5 ">
      <button
        onClick={goToPreviousPage}
        className="flex flex-row items-center justify-center bg-white border border-gray-300 rounded-lg w-[36px] h-[36px] "
      >
        <img src={arrowLeft} alt="" />
      </button>
      <span>
        Page {currentPage} of {totalPages}
      </span>
      <button
        onClick={goToNextPage}
        className="flex flex-row items-center justify-center bg-white border border-gray-300 rounded-lg w-[36px] h-[36px]"
      >
        <img src={arrowRight} alt="" />
      </button>
    </div>
  );
};
